<template>
   <div class="container">
    <section id="editContent" class="columnContainer settingPage">
      <div class="innerColumn">
        <h1 class="contentTitle">{{locale.thirdparty}}</h1>
        <div class="flexBox">
          <div class="flexInner">
            <div class="innerItem thirdpartyList">
              <ul class="thirdparties">
                <li v-for="(item, index) in thirdparty"
                  :key="index"
                  :class="{current: current === item.id}"
                  class="mb15"
                  @click="setThirdparty(item.id)">
                  <i><img :src="require(`@/assets/img/ico_thirdparty_${item.id}.png`)" alt=""></i>
                  {{locale[item.id]}}
                </li>
              </ul>
            </div>
          </div>
          <div class="flexInner" data-flex="2">
            <div v-if="currentThirdparty" class="innerItem">
              <component v-if="component"
                :is="component"
                :locale="locale"
                :infoData="currentThirdparty"
                @update="update"
                @semiSave="semiSave" />
            </div>
          </div>
        </div>
      </div>
      <div class="innerSide"></div>
    </section>
    <div id="setContent">
      <div class="innerItem">
        <button type="button" class="btn btnFull btnPrimary" @click="save">{{locale.save}}</button>
      </div>
    </div>
   </div>
</template>

<script>
import regExp from '@/common/regExp'

export default {
  name: 'Thirdparty',
  props: [
    'locale'
  ],
  components: {
  },
  computed: {
    currentThirdparty () {
      const current = this.current
      return this.thirdparty.find(x => x.id === current)
    },
    loader () {
      const current = this.currentThirdparty
      const thirdparty = current && current.id ? current.id.charAt(0).toUpperCase() + current.id.slice(1) : null
      if (!this.thirdparty) {
        return null
      }
      return () => thirdparty ? import(`@/components/Thirdparty/${thirdparty}.vue`) : null
    }
  },
  watch: {
    '$route' (to, from, next) {
      const auth = to.meta.authIds
      const id = to.params.id
      if (to.name === 'thirdpartyAuth' && !auth.includes(id)) {
        this.$router.push({
          name: 'thirdparty'
        })
      }
    }
  },
  created () {
    const current = this.$route.params.id || this.thirdparty[0].id
    this.current = current
  },
  mounted () {
    this.loader()
      .then(() => {
        this.component = () => this.loader()
      })
      .catch(() => {
        this.component = null
      })
    this.$nextTick(() => {
      this.init()
    })
  },
  data () {
    return {
      component: null,
      current: '',
      thirdparty: [
        {
          id: 'facebookmessanger',
          messangerId: null,
          active: false,
          mainOnly: true
        },
        {
          id: 'instagramfeed',
          appId: null,
          appSecret: null,
          active: false,
          code: null
        }
      ]
    }
  },
  methods: {
    init () {
      this.$store.commit('onLoading', true)
      this.$store.dispatch('thirdparty/getThirdparty').then((res) => {
        if (res) {
          const instagramAuthCode = this.$route.params.code
          const thirdparty = this.thirdparty.map(x => {
            const resItem = res.find(r => r.id === x.id)
            return {
              ...x,
              ...resItem,
              ...(x.id === 'instagramfeed' && instagramAuthCode) && {
                code: instagramAuthCode
              }
            }
          })
          this.thirdparty = thirdparty
        }
        this.$store.commit('onLoading', false)
      })
    },
    setThirdparty (thirdparty) {
      this.current = thirdparty
      this.$router.push({
        params: {
          id: thirdparty
        }
      })
      this.loader()
        .then(() => {
          this.component = () => this.loader()
        })
        .catch(() => {
          this.component = null
        })
    },
    update (data) {
      const id = data.id
      const info = data.info
      if (id && info) {
        this.thirdparty = this.thirdparty.map(x => {
          return x.id === id ? info : x
        })
      }
    },
    // 인스타그램 인증코드를 받은 후 (외부에서 다시 접근할 때) 토큰생성 등의 과정을 계속 진행하기 위해 중간에 세이브 해야함
    async semiSave (callback) {
      await this.$store.dispatch('thirdparty/setThirdparty', this.thirdparty)
      callback()
    },
    save () {
      if (window.confirm(this.locale.confirm_save)) {
        this.thirdparty = this.thirdparty.map(x => {
          return {
            ...x,
            ...x.id === 'instagramfeed' && {
              code: null
            }
          }
        })
        this.$store.commit('onLoading', true)
        this.$store.dispatch('thirdparty/setThirdparty', this.thirdparty).then((res) => {
          if (res) {
            alert(this.locale.complete_save)
            this.init()
          } else {
            alert(this.locale.alert_system_error)
          }
          this.$store.commit('onLoading', false)
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#editContent.columnContainer {
  .innerColumn {
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  .innerSide {
    width: 300px;
  }
  .sideBox {
    margin-left: 0;
    padding-left: 0;
  }
  .flexBox {
    flex: 1;
    overflow: hidden;
  }
  .flexInner {
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  .innerItem {
    flex: 1;
    overflow: auto;
    margin-bottom: 0;
    padding: 30px 45px;
  }
  .thirdpartyList {
    padding: 30px;
  }
}
.thirdparties {
  li {
    position: relative;
    padding: 15px 8px 15px 40px;
    color: $color-grey;
    border-radius: 4px;
    border: 1px solid $color_lgrey2;
    cursor: pointer;
    i {
      position: absolute;
      top: 12px;
      left: 8px;
      width: 24px;
    }
  }
  .current {
    color: $color-dark;
    border-color: $color-primary;
  }
}
</style>
